module.exports = __webpack_public_path__ + "img/order-fill.b1cb42e7.svg";